module.exports = __webpack_public_path__ + "static/media/room_15.9d65db78.jpg";